import { MathBase } from "../math/MathBase";
import { int } from "@goodgamestudios/math-utilities";
import { Localize } from "@goodgamestudios/localization";



/*[Deprecated(message="Use Localize.<datetime, time> instead")]*/
export class TimeStringHelper {
    public static TWO_TIME_FORMAT: string = 'nonMiliSec';
    public static DATE_DAY_FORMAT: string = 'dateDay';
    public static DATE_DAY_FORMAT_WITHOUT_YEAR: string = 'dateDayWithoutYear';
    public static DATE_SHORT_DAY_FORMAT: string = 'shortDay';
    public static DATE_TIMEOCLOCK_FORMAT: string = 'dateTimeOclock';
    public static DATE_TIMEOCLOCK_FORMAT_ADVANCED: string = 'dateTimeOclockAdvanced';
    public static ONE_TIME_FORMAT: string = 'onetime';
    public static ONE_TIME_FORMAT_ADVANCED: string = 'onetimeAdvanced';
    public static ONE_TIME_HOURS_FORMAT: string = 'onetimehour';
    public static HOURS_MINUTES_SECONDS_FORMAT: string = 'hoursMinutesSeconds';

    /** FORMAT: INPUT: I
     * SS:MM:SS oder MM:SS
     * */

    public static getShortTimeStringBySeconds(time: number, state: string = ""): string {
        return TimeStringHelper.getShortTimeString(time * 1000, state);
    }

    public static getShortTimeStringByMinutes(time: number, state: string = ""): string {
        return TimeStringHelper.getShortTimeString(time * 1000 * 60, state);
    }

    public static getShortTimeString(time: number, state: string = ""): string {
        if (time <= 0) {
            return '-';
        }
        let seconds: number = int(time / 1000);
        let minutes: number = int(seconds / 60);
        let hours: number = int(minutes / 60);
        let result: string = "";
        seconds -= minutes * 60;
        minutes -= hours * 60;
        result += TimeStringHelper.addLeadingZero(minutes);

        if ((state == TimeStringHelper.TWO_TIME_FORMAT && hours == 0) || state != TimeStringHelper.TWO_TIME_FORMAT) {
            result += ':';
            result += TimeStringHelper.addLeadingZero(seconds);
        }

        if (hours > 0 || state == TimeStringHelper.HOURS_MINUTES_SECONDS_FORMAT) {
            result = TimeStringHelper.addLeadingZero(hours) + ':' + result;
        }
        return Localize.digitalClock(result);
    }

    /**
     * time in seconds
     * return hours:minutes
     */
    public static getHoureMinutesTimeString(time: number): string {
        if (time <= 0) {
            return '-';
        }
        let minutes: number = int(time / 60);
        let hours: number = int(minutes / 60);
        let result: string = "";
        minutes -= hours * 60;

        if (minutes < 10) {
            result += '0';
        }
        result += minutes;
        result = hours + ':' + result;
        return Localize.digitalClock(result);
    }

    /**
     *  this methode generates out of seconds a time string of Format HH:MM:SS
     * @param time time in seconds
     * @return time in form HH:MM:SS
     *
     */
    public static getHoureMinuteSecondTimeString(time: number): string {
        if (time <= 0) {
            return Localize.digitalClock('00:00:00');
        }
        let seconds: number = int(time % 60);
        let minutes: number = int((time / 60) % 60);
        let hours: number = int(time / (60 * 60));
        let result: string = "";
        result += (hours < 10 ? '0' : '') + hours;
        result += ":" + (minutes < 10 ? '0' : '') + minutes;
        result += ":" + (seconds < 10 ? '0' : '') + seconds;
        return Localize.digitalClock(result);
    }

    /** For Dates
     * DATE_SHORT_DAY_FORMAT:        dd.mm or mm/dd
     * DATE_DAY_FORMAT:                DD.MM.YYYY or MM/DD/YYYY
     * @author Alexander Lutscher
     * @param state gives the state in which the date should be returned
     * @param time time in miliseconds since 1.1.1970
     * @param getTextById methode to get the translated textformat ( usually LanguageData:getTextById)
     * */
    public static getNewDateToString(time: number, state: string, getTextById: Function): string {
        if (time <= 0) {
            return '-';
        }

        let date: Date = new Date(time);

        // in case the type does not exist it will return "-"
        let dateToString: string = "-";

        // full date with day, month and year
        if (state == TimeStringHelper.DATE_DAY_FORMAT) {
            dateToString = getTextById('generic_dayformat', [TimeStringHelper.getDayStringFromDate(date), TimeStringHelper.getMonthStringFromDate(date), TimeStringHelper.getYearStringFromDate(date)]);
        }
        // short date only with day and month
        else if (state == TimeStringHelper.DATE_SHORT_DAY_FORMAT) {
            dateToString = getTextById('generic_dayformat_short', [TimeStringHelper.getDayStringFromDate(date), TimeStringHelper.getMonthStringFromDate(date)]);
        }

        return dateToString;
    }

    /**
     * returns the year of the date as fullYear
     * @param date
     * @return
     */
    protected static getYearStringFromDate(date: Date): string {
        return date.getFullYear().toString();
    }

    /**
     * returns the month of the date in form of MM
     * @param date
     * @return
     */
    protected static getMonthStringFromDate(date: Date): string {
        return ((date.getMonth() + 1) < 10) ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1).toString();
    }

    /**
     * return the day of the date in form of DD
     * @param date
     * @return
     */
    protected static getDayStringFromDate(date: Date): string {
        return (date.getDate() < 10) ? ('0' + date.getDate()) : date.getDate().toString();
    }

    /** Bei Zeitpunkten
     * DATE_SHORT_DAY_FORMAT:        dd.mm oder mm/dd
     * DATE_DAY_FORMAT:                xx.xx.xxxx
     * DATE_TIMEOCLOCK_FORMAT:        xx.xxUhr
     * DATE_TIMEOCLOCK_FORMAT_ADVANCED 09:xxUhr
     * */
    public static getDateToString(time: number, state: string, getTextById: Function): string {
        if (time <= 0) {
            return '-';
        }
        let result: string = '';
        let d: Date = new Date(time);

        if (state == TimeStringHelper.DATE_DAY_FORMAT_WITHOUT_YEAR) {
            return result = d.getDate() + '.' + (d.getMonth() + 1);
        }

        if (state == TimeStringHelper.DATE_DAY_FORMAT) {
            return result = d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear();
        }

        if (state == TimeStringHelper.DATE_SHORT_DAY_FORMAT) {
            return getTextById('generic_dayformat_short', [(d.getDate() < 10) ? ('0' + d.getDate()) : d.getDate().toString(), ((d.getMonth() + 1) < 10) ? ('0' + (d.getMonth() + 1)) : (d.getMonth() + 1).toString]);
        }

        if (state == TimeStringHelper.DATE_TIMEOCLOCK_FORMAT) {
            result += d.getHours() + '.';

            if (d.getMinutes() < 10) {
                result += '0';
            }
            result += d.getMinutes();
        }

        if (state == TimeStringHelper.DATE_TIMEOCLOCK_FORMAT_ADVANCED) {
            if (d.getHours() < 10) {
                result += '0';
            }
            result += d.getHours() + ':';

            if (d.getMinutes() < 10) {
                result += '0';
            }
            result += d.getMinutes();
        }
        return result + getTextById('timeformat_clock');
    }

    private static multiOrShortTimeString(timeString: string, value: number, shortTimeString: boolean): string {
        let result: string = timeString;

        if (shortTimeString) {
            result += "_short";
        }
        else {
            result += (value != 1) ? 's' : '';
        }
        return result;
    }

    /**
     * Bei Zeitabschnitten, time in Sekunden
     * TWO_TIME_FORMAT:            xxT xxStd    oder    xxStd xxMin oder xxMin xxSek
     * ONE_TIME_FORMAT:            xxT oder xxStd oder xxMin
     * ONE_TIME_FORMAT_ADVANCED: x,xT  oder xxStd oder xxMin
     * ONE_TIME_HOURS_FORMAT:    xxxStd oder xxMin
     * */
    public static getTimeToString(time: number, state: string, getTextById: Function, lineBreakPerTime: boolean = false, shortTimeString: boolean = false, useHoursWithComma: boolean = false, roundToNextHour: boolean = false): string {
        if (time <= 0) {
            return '-';
        }

        // Round if bigger than 1 hour
        if (roundToNextHour && !shortTimeString) {
            time = TimeStringHelper.roundTimeToNextHour(time);
        }
        let milisec: number = (time * 1000);
        let seconds: number = int(milisec / 1000);
        let minutes: number = int(seconds / 60);
        let hours: number = int(minutes / 60);
        let days: number = int(hours / 24);
        let months: number = int(days / 30);
        let result: string = '';
        let timeString: string = '';
        milisec -= seconds * 1000;
        seconds -= minutes * 60;
        minutes -= hours * 60;
        let resultValue: number;

        if (state != TimeStringHelper.ONE_TIME_HOURS_FORMAT) {
            hours -= days * 24;
            days -= months * 30;
        }

        if (state != TimeStringHelper.ONE_TIME_HOURS_FORMAT && months > 0) {
            timeString = TimeStringHelper.multiOrShortTimeString('generic_month', months, shortTimeString);
            result = months + ' ' + getTextById(timeString);

            if (state == TimeStringHelper.ONE_TIME_FORMAT_ADVANCED) {
                resultValue = (MathBase.round(days / 30, 1) + months);
                timeString = TimeStringHelper.multiOrShortTimeString('generic_month', resultValue, shortTimeString);
                return resultValue + ' ' + getTextById(timeString);
            }
            else if (state == TimeStringHelper.ONE_TIME_FORMAT) {
                return result;
            }
        }

        if (state != TimeStringHelper.ONE_TIME_HOURS_FORMAT && days > 0) {
            timeString = TimeStringHelper.multiOrShortTimeString('generic_day', days, shortTimeString);

            if (result.length > 0) {
                result += (lineBreakPerTime) ? "\n" : " ";
            }
            result += days + ' ' + getTextById(timeString);

            if (state == TimeStringHelper.ONE_TIME_FORMAT_ADVANCED) {
                resultValue = (MathBase.round(hours / 24, 1) + days);
                timeString = TimeStringHelper.multiOrShortTimeString('generic_day', resultValue, shortTimeString);
                return resultValue + ' ' + getTextById(timeString);
            }
            else if (state == TimeStringHelper.ONE_TIME_FORMAT) {
                return result;
            }
            else if (months > 0) {
                return result;
            }
        }

        if (hours > 0) {

            // useHoursComma
            if (useHoursWithComma && days > 0) {
                let commaNumber: number = MathBase.floor(minutes / 60, 1);

                if (commaNumber >= 1) {
                    hours++;
                }
                else if (commaNumber > 0) {
                    return result + " " + hours + getTextById("generic_comma") + commaNumber.toString().substr(commaNumber.toString().indexOf(".") + 1) + " " + getTextById("generic_hours");
                }
            }
            timeString = TimeStringHelper.multiOrShortTimeString('generic_hour', hours, shortTimeString);

            if (result.length > 0) {
                result += (lineBreakPerTime) ? "\n" : " ";
            }
            result += hours + ' ' + getTextById(timeString);

            if (state.indexOf("onetime") >= 0 || (state == TimeStringHelper.TWO_TIME_FORMAT && days > 0)) {
                return result;
            }
        }

        if (minutes > 0) {
            timeString = TimeStringHelper.multiOrShortTimeString('generic_minute', minutes, shortTimeString);

            if (result.length > 0) {
                result += (lineBreakPerTime) ? "\n" : " ";
            }
            result += minutes + ' ' + getTextById(timeString);

            if (state.indexOf("onetime") >= 0 || (state == TimeStringHelper.TWO_TIME_FORMAT && (hours > 0 || days > 0))) {
                return result;
            }
        }
        else if (state == TimeStringHelper.TWO_TIME_FORMAT && result != '') {
            return result;
        }

        if (seconds > 0) {
            timeString = TimeStringHelper.multiOrShortTimeString('generic_second', seconds, shortTimeString);

            if (result.length > 0) {
                result += (lineBreakPerTime) ? "\n" : " ";
            }
            result += seconds + ' ' + getTextById(timeString);
        }
        return result;
    }

    /**
     * roundTimeForNextHourOrDay
     * this function will add half of a hour to the time to prevent usability confusions
     * @param time: Time in ms
     * */
    private static roundTimeToNextHour(time: number): number {
        let hour: number = 60 * 60;

        // add half of a month/day/hour
        if (time > hour) {
            time += hour * 0.5;
        }
        return time;
    }

    /**
     * Adds a leading zero to a number, if needed
     * Examples:  5 > "05", 11 > "11"
     * @param num    any number
     * @return        number as String
     */
    private static addLeadingZero(num: number): string {
        let result: string = String(num);

        if (num < 10) {
            result = '0' + num;
        }

        return result;
    }

    public static getDateStringFromDate(date: Date, getTextById: Function): string {
        return getTextById("generic_dayformat", [date.getDate(), date.getMonth() + 1, date.getFullYear()]);
    }

    public static getTimeStringFromDate(date: Date, getTextById: Function, state: string = TimeStringHelper.TWO_TIME_FORMAT): string {
        let dateString: string = "";

        let hours: string;

        if (date.getHours() < 10) {
            hours = "0" + date.getHours();
        }
        else {
            hours = String(date.getHours());
        }
        dateString += hours;

        let minutes: string;

        if (date.getMinutes() < 10) {
            minutes = "0" + date.getMinutes();
        }
        else {
            minutes = String(date.getMinutes());
        }
        dateString += ":" + minutes;

        if (state == TimeStringHelper.HOURS_MINUTES_SECONDS_FORMAT) {
            let seconds: string;
            if (date.getSeconds() < 10) {
                seconds = "0" + date.getSeconds();
            }
            else {
                seconds = String(date.getSeconds());
            }
            dateString += ":" + seconds;
        }

        return Localize.digitalClock(dateString);
    }

    /**
     * Returns a human readable time string
     * @param time                    time in seconds
     * @param getTextById            text localization function
     * @param format                [optional] flag for time formats, affects only time spans &lt; 1 day
     *                                 default:                        1 hour 30 minutes
     *                                 HOURS_MINUTES_SECONDS_FORMAT:    01:30:00
     *
     * @return                        readable time string
     */
    public static getCommaTimeStringFromSeconds(time: number, getTextById: Function, format: string = ''): string {
        if (time <= 0) {
            return '-';
        }
        let timeInMilisec: number = (time * 1000);
        let timeInSeconds: number = int(timeInMilisec / 1000);
        let timeInMinutes: number = int(timeInSeconds / 60);
        let timeInHours: number = int(timeInMinutes / 60);
        let timeInDays: number = int(timeInHours / 24);
        let timeInMonths: number = int(timeInDays / 30);
        let months: number = timeInMonths;
        let days: number = int(timeInDays - timeInMonths * 30);
        let hours: number = int(timeInHours - timeInDays * 24);
        let minutes: number = int(timeInMinutes - timeInHours * 60);
        let seconds: number = int(timeInSeconds - timeInMinutes * 60);
        let commaNumber: number;

        if (months > 0) {
            commaNumber = MathBase.ceil(days / 30, 1);

            if (commaNumber >= 1) {
                months++;
            }
            else if (commaNumber > 0) {
                return months + getTextById("generic_comma") + commaNumber.toString().substr(commaNumber.toString().indexOf(".") + 1) + " " + getTextById("generic_months");
            }
            return months + " " + getTextById(TimeStringHelper.multiOrShortTimeString('generic_month', months, false));
        }

        if (days > 0) {
            commaNumber = MathBase.ceil(hours / 24, 1);

            if (commaNumber >= 1) {
                days++;
            }
            else if (commaNumber > 0) {
                return days + getTextById("generic_comma") + commaNumber.toString().substr(commaNumber.toString().indexOf(".") + 1) + " " + getTextById("generic_days");
            }
            return days + " " + getTextById(TimeStringHelper.multiOrShortTimeString('generic_day', days, false));
        }

        if (format == TimeStringHelper.HOURS_MINUTES_SECONDS_FORMAT) {
            return TimeStringHelper.getShortTimeString(timeInMilisec, TimeStringHelper.HOURS_MINUTES_SECONDS_FORMAT);
        }
        else {
            if (hours > 0) {
                commaNumber = MathBase.ceil(minutes / 60, 1);

                if (commaNumber >= 1) {
                    hours++;
                }
                else if (commaNumber > 0) {
                    return hours + getTextById("generic_comma") + commaNumber.toString().substr(commaNumber.toString().indexOf(".") + 1) + " " + getTextById("generic_hours");
                }
                return hours + " " + getTextById(TimeStringHelper.multiOrShortTimeString('generic_hour', hours, false));
            }

            if (minutes > 0) {
                /*commaNumber =  MathBase.ceil((seconds / 60),1);
                 if(commaNumber >=1 )
                 minutes++;
                 else if(commaNumber > 0)
                 return minutes + getTextById("generic_comma") + commaNumber.toString().substr(commaNumber.toString().indexOf(".")+1) + " " + getTextById("generic_minutes");*/
                return minutes + " " + getTextById(TimeStringHelper.multiOrShortTimeString('generic_minute', minutes, false));
            }

            if (seconds > 0) {
                /*commaNumber =  MathBase.ceil((milisec / 1000),1);
                 if(commaNumber >=1 )
                 seconds++;
                 else if(commaNumber > 0)
                 return seconds + getTextById("generic_comma") + commaNumber.toString().substr(commaNumber.toString().indexOf(".")+1) + " " + getTextById("generic_seconds");*/
                return seconds + " " + getTextById(TimeStringHelper.multiOrShortTimeString('generic_second', seconds, false));
            }
        }

        return "";
    }

    public static getPrimeTimeToString(timeInSeconds: number, getTextById: Function): string {
        if (timeInSeconds <= 0) {
            return '-';
        }
        let seconds: number = int(timeInSeconds);
        let minutes: number = int(seconds / 60);
        let result: string = '';
        let timeString: string = '';
        seconds -= minutes * 60;

        if (minutes > 0) {
            timeString = TimeStringHelper.multiOrShortTimeString('generic_minute', minutes, false);
            result += minutes + ' ' + getTextById(timeString);
            return result;
        }
        else {
            timeString = TimeStringHelper.multiOrShortTimeString('generic_second', seconds, false);
            result += seconds + ' ' + getTextById(timeString);
            return result;
        }
    }

    /**
     * will return a formatted timestring - uses textids with placeholders
     * @param timeInSeconds the time to be interpreted
     * @param textIdOver24h textid to be used when &gt;24h - format is {0}d{1}h{2}m
     * @param textIdUnder24h textid to be used when &lt;24h - format is {0}h{1}m
     * @param getTextById getTextById function passed by the project
     * @return formatted time without seconds
     *
     */
    public static getTextIdFormattedTimeString(timeInSeconds: number, textIdOver24h: string, textIdUnder24h: string, getTextById: Function): string {
        let days: number = Math.floor(timeInSeconds / (60 * 60 * 24));
        let minutes: number = int((timeInSeconds / 60) % 60);
        let hours: number = int((timeInSeconds / (60 * 60)) % 24);

        if (days == 0) {
            return getTextById(textIdUnder24h, [hours, minutes]);
        }
        else {
            return getTextById(textIdOver24h, [days, hours, minutes]);
        }
    }
}
